import { BaseSyntheticEvent, useEffect, useState } from 'react';
import { Badge, Button, Col, Container, Dropdown, Image, Row } from 'react-bootstrap';
import { AiOutlineUnorderedList } from 'react-icons/ai';
import { FaFileInvoiceDollar, FaUserAlt, FaUserCircle } from 'react-icons/fa';
import { IoIosWallet } from 'react-icons/io';
import { RiLogoutBoxFill } from 'react-icons/ri';
import { BiMenu } from 'react-icons/bi';
import { Link, useHistory } from 'react-router-dom';

import logo from '../assets/logo_stride.png';
import ForgotPasswordModal from '../components/modal/forgot-password-modal/forgot-password-modal.component';
import LoginModal from '../components/modal/login-modal/login-modal.component';
import SignupByEmailModal from '../components/modal/signup-by-email-modal/signup-by-email-modal.component';
import SignupModal from '../components/modal/signup-modal/signup-modal.component';
import SetPasswordModal from '../components/modal/set-password-modal/set-password-modal.component';
import { AuthActionEnum } from '../enums/app.enum';
import { useAuthState } from '../states/auth.state';
import { useModalState } from '../states/modal.state';
import './SHeader.scss';

const SHeader = () => {
  const history = useHistory()
  const authState = useAuthState()
  const modalState = useModalState()

  const openLoginModal = () => {
    // setShow(true)
    modalState.showModal('showLogin')
  }

  const handleCloseSetPassword = () => {
    modalState.setValue('showSetPassword', false)
  }

  const openSignupModal = () => {
    // setShowSignup(true)
    modalState.showModal('showSignUp')
  }
  const handleLogout = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    authState.logout()
    history.push('/')
  }

  const handleCloseLogin = (data: string) => {
    if (data === AuthActionEnum.OPEN_SIGNUP) {
      modalState.showModal('showSignUp')
    } else if (data === AuthActionEnum.OPEN_FORGOT) {
      modalState.showModal('showForgot')
    } else {
      modalState.setValue('showLogin', false)
    }
  }

  const handleCloseSignup = (data: any) => {
    if (data === AuthActionEnum.OPEN_SIGN_UP_BY_EMAIL) {
      modalState.showModal('showSignUpByEmail')
    } else if (data === AuthActionEnum.OPEN_LOGIN) {
      modalState.showModal('showLogin')
    } else {
      modalState.setValue('showSignUp', false)
    }
  }

  const handleCloseForgot = (data: any) => {
    if (data === AuthActionEnum.OPEN_LOGIN) {
      modalState.showModal('showLogin')
    } else {
      modalState.setValue('showForgot', false)
    }
  }

  const handleCloseSignupByEmail = (data: string) => {
    if (data === AuthActionEnum.OPEN_LOGIN) {
      modalState.showModal('showLogin')
    } else {
      modalState.setValue('showSignUpByEmail', false)
    }
  }

  return (
    <header className='s-header mb-3'>
      <div className="bg-dark text-white">
        <Container>
          <p className='p-0 m-0'>CONTACT (+65) 6477 5977</p>
        </Container>
      </div>
      <div>
        <Container>
          <Row className="align-items-center py-2">
            <Col className='px-0 text-center text-md-left flex-grow-0' xs={6} md={5}>
              <Link to="/" ><Image src={logo} className="image-logo w-100" /></Link>
            </Col>
            <Col className='px-0 ml-auto text-right' xs={6} md={7}>
              {authState.get().currentUser ?
                <div className="d-inline">
                  <Dropdown className='d-inline-block'>
                    <Dropdown.Toggle variant='outline-secondary' className="p-0 pl-3 s-button s-button-fullname">
                      <span className="header-username">{authState.get().currentUser?.first_name}</span>
                      <FaUserCircle className='ml-2' size={40} style={{ color: '#C4C4C4' }} />

                    </Dropdown.Toggle>

                    <Dropdown.Menu align='left'>
                      <Dropdown.Item size='sm' onClick={e => history.push('/booking-list')}><AiOutlineUnorderedList className="mr-1 mt-n1" /> Manage Booking</Dropdown.Item>
                      <Dropdown.Item size='sm' onClick={handleLogout}><RiLogoutBoxFill className="mr-1 mt-n1" /> Sign out</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                :
                <div className='d-inline-block'>
                  <Button variant="outline-secondary" className="s-button" onClick={openLoginModal}>LOGIN <FaUserAlt /></Button>
                </div>
              }
            </Col>
          </Row>
        </Container>
      </div>
      <div className="bg-corporate">
        <div className="container">
          <span className="margin-corporate d-flex">
            <Dropdown className='mt-n1 dropdown-icon-menu'>
              {authState.get().currentUser && <Dropdown.Toggle>
                <BiMenu style={{ fontSize: 'xx-large' }} />
              </Dropdown.Toggle>
              }
              <Dropdown.Menu align='left'>
                <Dropdown.Item size='sm' onClick={e => history.push('/booking-create')}>CREATE BOOKING</Dropdown.Item>
                <Dropdown.Item size='sm' onClick={e => history.push('/booking-list')}>BOOKING LIST</Dropdown.Item>
                {authState.get().currentUser?.role === 'Admin' && (
                  <Dropdown.Item size='sm' onClick={e => history.push('/agent')}>AGENT LIST</Dropdown.Item>
                )}
                {authState.get().currentUser?.role !== 'User' && (
                  <Dropdown.Item size='sm' onClick={e => history.push('/invoices')}>INVOICES</Dropdown.Item>
                )}
                <Dropdown.Item size='sm' onClick={e => history.push('/reports')}>REPORTS</Dropdown.Item>
                <Dropdown.Item size='sm' onClick={e => history.push('/driver-location')}>DRIVER LOCATION</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>CORPORATE
          </span>
        </div>
      </div>

      {modalState.get().showLogin && <LoginModal show={modalState.get().showLogin} onHide={handleCloseLogin} pathto={modalState.get().pathto} />}
      {modalState.get().showSignUp && <SignupModal show={modalState.get().showSignUp} onHide={handleCloseSignup} />}
      {modalState.get().showForgot && <ForgotPasswordModal show={modalState.get().showForgot} onHide={handleCloseForgot} />}
      {modalState.get().showSignUpByEmail && <SignupByEmailModal show={modalState.get().showSignUpByEmail} onHide={handleCloseSignupByEmail} />}
      {modalState.get().showSetPassword && <SetPasswordModal show={modalState.get().showSetPassword} onHide={handleCloseSetPassword} />}
    </header>
  )
}

export default SHeader;
